import factory from './optionManager.factory.js';
import DefaultTabInnerComponent from '../../../tab/defaulTabInner.js';
import DefaultOptions from './defaultOptions.js';
var getDeps = function getDeps() {
  var op = new DefaultOptions(DefaultTabInnerComponent);
  return {
    globalDefaultOptions: op.getOptions()
  };
};
export default factory.bind(null, getDeps);